require('./brokerPensionPlanContributionView.scss');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { recordProcess } = require("utilities/tagging");


// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @actions
const brokerPensionPlanContributionActions = require('actions/brokerPensionPlanContribution');
const brokerPensionPlanPeriodicalContributionActions = require('actions/brokerPensionPlanPeriodicalContribution');
const brokerPensionPlansActions = require('actions/brokerPensionPlans');
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');

// @components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const BrokerPensionPlanPeriodicStep1 = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicStep1/pensionPlanPeriodicStep1');
const BrokerPensionPlanPeriodicStep2 = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicStep2/pensionPlanPeriodicStep2');
const BrokerPensionPlanPeriodicSuccess = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicSuccess/pensionPlanPeriodicSuccess');
const BrokerPensionPlanHeader = require('components/broker/brokerPensionPlanHeader/brokerPensionPlanHeader');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');

// @Contact Center constants
const {
    PENSION_PLAN_STANDARD,
    PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
    PENSION_PLAN_PRODUCT_SUB_TYPE,
} = require('constants/contactCenter/pensionPlans');

// @Contact Center
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const NextButtonWrapper = require("components/contactCenter/nextButtonWrapper/nextButtonWrapper");
const { PensionPlanLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/pensionPlanLegalConfirmation/pensionPlanLegalConfirmation');

// @constants
const {
    BROKER_PG_URL,
    BROKER_PLANS_HELP_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL
} = require('constants/index');

class BrokerPensionPlanPeriodicContributionView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleShowWizard = this.handleShowWizard.bind(this);
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);

        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY
        };
    }

    componentWillMount() {
        const { planId, contributionDate } = this.props.match.params;
        this.props.getPensionPlans(planId);
        const walletPlan = this.findWalletPlan();
        this.props.setContract(walletPlan, this.props.history);
        this.props.getPeriodicalContribution(planId);
        if (contributionDate) {
            this.props.getPeriodicalContributionDetails(contributionDate);
        }

    }

    componentDidUpdate(prevProps){
        const { immPensionPlanPeriodicalContribution } = this.props;
        const immPensionPlanPeriodicalContributionPrev = prevProps.immPensionPlanPeriodicalContribution;
        if (
            immPensionPlanPeriodicalContributionPrev.get('isFetching') &&
            !immPensionPlanPeriodicalContribution.get('isFetching')
        ) {
            const hasActiveAportation = immPensionPlanPeriodicalContribution.get('activeAportation');
            if (hasActiveAportation) {
                recordProcess(
                    'proc-broker-aporte-planes-pension-periodic',
                    'error',
                    {
                        tipoError: formatText('pensionPlanPeriodicalContribution-emptyStateActiveAportationTaggingError'),
                    },
                    true
                );
            }
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    buildSuccessful() {
        const { immPensionPlanContribution, immStocksContracts } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-lg-12">
                    <BrokerPensionPlanPeriodicSuccess
                        immPensionPlanContribution={immPensionPlanContribution}
                        immStocksContracts={immStocksContracts}
                    />
                </div>
            </div>
        );
    }

    handleShowWizard (){
        this.setState({
            displayWizard: true,
        })
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    buildEmptyState() {
        const message1 = formatText('pensionPlanPeriodicalContribution-emptyStateActiveAportationMessage1');
        const message2 = formatText('pensionPlanPeriodicalContribution-emptyStateActiveAportationMessage2');
        const message3 = formatText('pensionPlanPeriodicalContribution-emptyStateActiveAportationMessage3');
        const linkButton1 = (
            <OKButton
                modifier="secondary"
                to={MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL}
            >
                <FormattedText value="pensionPlanContribution-successMainButtonEdit" />
            </OKButton>
        );
        const linkButton2 = (
            <OKButton
                modifier="ghost"
                to={BROKER_PG_URL}
            >
                <FormattedText value="broker-convenienceMifidTestGoBackToMyWallet" />
            </OKButton>
        );
        const secondaryText = (
            <div className="broker-pension-plan-empty-state">
                <span className="broker-pension-plan-empty-state__text">
                    {message1}
                </span>
                <span className="broker-pension-plan-empty-state__text">
                    {message2}
                </span>
                <span className="broker-pension-plan-empty-state__text">
                    {message3}
                </span>
            </div>
        );
        const buttons = (
            <footer className="broker-pension-plan-empty-state__footer">
                <div className="broker-pension-plan-empty-state__first-button">
                    {linkButton1}
                </div>
                <div className="broker-pension-plan-empty-state__second-button">
                    {linkButton2}
                </div>
            </footer>
        );

        return (
            <ContentBox>
                <EmptyState secondaryText={secondaryText} button={buttons} iconType="noitems-wealth"/>
            </ContentBox>
        );
    }

    buildWizard() {
        const {
            immPensionPlan,
            immPensionPlanContribution,
            immPensionPlanPeriodicalContribution,
            immAccounts,
            validateStep,
            setVisibleStep,
            setWillCancel,
            setOriginalAmount,
            setRevAnual,
            setPeriodiclyMonthly,
            setPeriodiclyAmount,
            setValidityDate,
            setAvailablePercentageInput,
            setPercentagePeriodiclyAmount,
            setPeriodicity,
            onToggleDisclaimer,
            setDocumentsRead
        } = this.props;

        const { displayWizard } = this.state;

        const immSteps = immPensionPlanContribution.get('steps');
        const stepLoading = immPensionPlanContribution.get('isFetching');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.props.handleFinish,
            cancel: this.handleCancel
        };
        const step1Title = (!immPensionPlanContribution.get('isEditMode') ? formatText('pensionPlanContribution-headerPeridicTitle') : formatText('pensionPlanContribution-headerPeriodicTitleEdit'));
        const headerMenuData = {
            title: step1Title,
            linksData: ['']
        };
        const isEditMode = immPensionPlanContribution.get('isEditMode');
        const finalButton = isEditMode ? "pensionPlanContribution-finalButtonModify" : "pensionPlanContribution-finalButton";

        const pasoProceso = immPensionPlanContribution.get('visibleStep') && immPensionPlanContribution.get('visibleStep') !== 1
        ? `paso_${immPensionPlanContribution.get('visibleStep')-1}`
        : 'inicio';

        const tealium = immPensionPlanContribution.get('visibleStep')
        ? {
            pasoProceso: pasoProceso,
        } : null;

        return (
            displayWizard && <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immPensionPlanContribution.get('visibleStep')}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
                tealium={tealium}
                isTaggingSecondVersion
            >
                <WizardStep position="first" cancelButton={true}>
                    <BrokerPensionPlanPeriodicStep1
                        immPensionPlanContribution={immPensionPlanContribution}
                        immBrokerPensionPlans={immPensionPlan}
                        immAccounts={immAccounts}
                        setOriginalAmount={setOriginalAmount}
                        setPeriodiclyMonthly={setPeriodiclyMonthly}
                        setRevAnual={setRevAnual}
                        setPeriodiclyAmount={setPeriodiclyAmount}
                        setValidityDate={setValidityDate}
                        setAvailablePercentageInput={setAvailablePercentageInput}
                        setPeriodicity={setPeriodicity}
                        setPercentagePeriodiclyAmount={setPercentagePeriodiclyAmount}
                        immPensionPlanPeriodicalContribution={immPensionPlanPeriodicalContribution}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton={finalButton}
                    addLoadingBehaviour={true}
                    isLoading={stepLoading}
                >
                    <BrokerPensionPlanPeriodicStep2
                        immPensionPlanContribution={immPensionPlanContribution}
                        onToggleDisclaimer={onToggleDisclaimer}
                        setDocumentsRead={setDocumentsRead}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    findWalletPlan() {
        const { immBrokerWallets, immPensionPlanContribution } = this.props;
        const { planId } = this.props.match.params;

        const contractNumber = immPensionPlanContribution.get('contractNumber');
        const planIdDivided = planId.split('-');

        return immBrokerWallets.get('plansList').find((immPlan) => {
            const planProduct = immPlan.getIn(['contrato', 'producto']);
            const planSubProduct = immPlan.getIn(['criterios', 'c1', 'subtipoproducto']);
            const productAndSubProductMatch = (
                planProduct === planIdDivided[0] && planSubProduct === planIdDivided[1]
            );

            if (contractNumber) {
                return (
                    productAndSubProductMatch &&
                    immPlan.getIn(['contrato', 'numerodecontrato']) === contractNumber
                );
            }

            return productAndSubProductMatch;
        });
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    buildNextButtonWrappedLegalConfirmation() {

        const {
            immPensionPlan,
            immProfileFields,
            requestProfile,
            resetPrecontractualMail,
            sendPreContractualMail,
            immPreContractualMail,
        } = this.props;

        const {
            selectedLegalConfirmationValue,
        } = this.state;

        const { name, dgscode, secId } = immPensionPlan.get('pensionPlan').toJS();

        const sendMailParams = {
            productName: name,
            standar: PENSION_PLAN_STANDARD,
            type: PENSION_PLAN_CONTRIBUTION_PRODUCT_TYPE,
            subType: PENSION_PLAN_PRODUCT_SUB_TYPE
        };

        const pensionPlanLegalDesclaimer = "pensionPlanLegalConfirmation-legalDisclaimerQuestionFirstStatementPeriodicContrib";
        const pensionPlanLegalFirstQuestion = "pensionPlanLegalConfirmation-legalDisclaimerDocumentsLinksContributionsFirstStatement";

        const isAbleToContinueToWizard = immPreContractualMail.get('mailSent') && selectedLegalConfirmationValue === SELECTED_VALUES.YES && !immProfileFields.get('error');

        return(
            <article className="content-box broker-hire-pension-plan__legal-confirmation" id="printable-wizard">
                <NextButtonWrapper
                    canContinue={isAbleToContinueToWizard}
                    onContinue={this.handleShowWizard}
                >
                    <PensionPlanLegalConfirmation
                        planDgsCode={dgscode}
                        planSecId={secId}
                        pensionPlanFullName={name}
                        requestProfile={requestProfile}
                        immProfileFields={immProfileFields}
                        onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                        selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                        sendMail={sendPreContractualMail}
                        resetMailState={resetPrecontractualMail}
                        immPreContractualMail={immPreContractualMail}
                        sendMailParams={sendMailParams}
                        pensionPlanLegalDesclaimer={pensionPlanLegalDesclaimer}
                        pensionPlanLegalFirstQuestion={pensionPlanLegalFirstQuestion}
                    />
                </NextButtonWrapper>
            </article>
        );
    }

    render() {
        const {
            immBrokerProductAdvancedSearch,
            immPensionPlan,
            immPensionPlanContribution,
            immPensionPlanPeriodicalContribution,
            immHirePensionPlan,
            flagBasedFeatures,
            history
        } = this.props;
        const isEditMode = immPensionPlanContribution.get('isEditMode');
        const breadcrumbModifyLink = formatText('pensionPlanPeriodicalContribution-breadcrumbModifyLink');
        const breadcrumbNewAportationLink = formatText('broker-myInvestmentsPensionPlanPeriodicContribution');
        const breadcrumbLink = isEditMode ? breadcrumbModifyLink : breadcrumbNewAportationLink;
        const isFetching = immPensionPlanContribution.get('isFetching');
        const isFetchingPeriodicalContribution = immPensionPlanPeriodicalContribution.get('isFetching');
        const hasActiveAportation = immPensionPlanPeriodicalContribution.get('activeAportation');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('plans-plans'),
                url: MYPROFILE_BROKER_PLANS_URL
            },
            {
                text: breadcrumbLink
            }
        ];
        const secId = immPensionPlan.get('pensionPlan').get('secId');
        const periodicAportationTitle = formatText('pensionPlanContribution-title');
        const editPeriodicAportationTitle = formatText('pensionPlanContribution-titleEdit');
        const headerTitle = !isEditMode ? periodicAportationTitle : editPeriodicAportationTitle;
        const hasPensionPlan = !!(immPensionPlanContribution.get('pensionPlan') && !isFetching && !isFetchingPeriodicalContribution && immPensionPlan.get('pensionPlan').size && secId);
        let bodyContent;

        let content = <LoadingSection />;
        if (immPensionPlanContribution.get('pensionPlan') && !isFetching && !isFetchingPeriodicalContribution && immPensionPlan.get('pensionPlan').size) {
            content = <BrokerPensionPlanHeader immPensionPlan={immPensionPlan} immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch} />;
        }

        if (__CONTACT_CENTER__ && !this.state.displayWizard && secId && !immHirePensionPlan.get('submitSuccessful')) {
            bodyContent = this.buildNextButtonWrappedLegalConfirmation();
        }
        else if (hasPensionPlan) {
            bodyContent = this.buildWizard();
        }

        if(hasActiveAportation && !isFetching && !isEditMode && !isFetchingPeriodicalContribution) {
            bodyContent = this.buildEmptyState();
        } else if (immPensionPlanContribution.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        }

        const ffUsPersonPensionPlansPeriodicContribution = flagBasedFeatures.get('wealth_pension_plans_periodic_contribution_us_person');
        const contentRender = (
            <section className="broker-pension-plan-contribution-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={headerTitle}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            to={BROKER_PLANS_HELP_URL}
                        >
                            <FormattedText
                                format="firstUppercase"
                                value="pensionPlanContribution-headerSecondLink"
                            />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-pension-plan-contribution-view__body">
                    {content}
                    <div className="broker-pension-plan-contribution-view__wizard">
                        {bodyContent}
                    </div>
                </section>
            </section>
        )

        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonPensionPlansPeriodicContribution}
                titleKey={'us_person_popup-pension_plans_periodic_contribution_title'}
                description={'us_person_popup-pension_plans_periodic_contribution_message'}
                buttonClick={() => history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerPensionPlanPeriodicContributionView.propTypes = {
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immPensionPlanContribution: PropTypes.object.isRequired,
    immPensionPlanPeriodicalContribution: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired,
    getPensionPlans: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setOriginalAmount: PropTypes.func.isRequired,
    setRevAnual: PropTypes.func.isRequired,
    setPeriodiclyMonthly: PropTypes.func.isRequired,
    setPeriodiclyAmount: PropTypes.func.isRequired,
    setValidityDate: PropTypes.func.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    setAvailablePercentageInput: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setPercentagePeriodiclyAmount: PropTypes.func.isRequired,
    getPeriodicalContributionDetails: PropTypes.func.isRequired,
    getPeriodicalContribution: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immHirePensionPlan: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
};

module.exports.constructor = BrokerPensionPlanPeriodicContributionView;
module.exports.BrokerPensionPlanPeriodicContributionView = connect(
    state => ({
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immPensionPlanContribution: state.brokerPensionPlanContribution,
        immBrokerWallets: state.brokerWallets,
        immStocksContracts: state.brokerStocksContract,
        immPensionPlan: state.brokerPensionPlans,
        immPensionPlanPeriodicalContribution: state.brokerPensionPlanPeriodicalContribution,
        immAccounts: state.accounts,
        immHirePensionPlan: state.brokerHirePensionPlan,
        immPreContractualMail: state.preContractualMail,
        immProfileFields: state.profile,
        flagBasedFeatures: state.flagBasedFeatures,
    }),{
        validateStep: brokerPensionPlanContributionActions.validateStep,
        setPeriodicity: brokerPensionPlanContributionActions.setPeriodicity,
        setAvailablePercentageInput: brokerPensionPlanContributionActions.setAvailablePercentageInput,
        setVisibleStep: brokerPensionPlanContributionActions.setVisibleStep,
        setWillCancel: brokerPensionPlanContributionActions.setWillCancel,
        handleFinish: brokerPensionPlanContributionActions.finish,
        reset: brokerPensionPlanContributionActions.reset,
        getPensionPlans: brokerPensionPlansActions.requestPensionPlan,
        setContract: brokerPensionPlanContributionActions.setContract,
        setOriginalAmount: brokerPensionPlanContributionActions.setOriginalAmount,
        setRevAnual: brokerPensionPlanContributionActions.setRevAnual,
        setPeriodiclyMonthly: brokerPensionPlanContributionActions.setPeriodiclyMonthly,
        setPeriodiclyAmount: brokerPensionPlanContributionActions.setPeriodiclyAmount,
        setPercentagePeriodiclyAmount: brokerPensionPlanContributionActions.setPercentagePeriodiclyAmount,
        setValidityDate: brokerPensionPlanContributionActions.setValidityDate,
        onToggleDisclaimer: brokerPensionPlanContributionActions.toggleDisclaimer,
        getPeriodicalContributionDetails: brokerPensionPlanContributionActions.getPeriodicalContribution,
        getPeriodicalContribution: brokerPensionPlanPeriodicalContributionActions.getPeriodicalContribution,
        requestProfile: profileActions.requestProfile,
        sendPreContractualMail: preContractualMailInfoActions.sendPreContractualMail,
        resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
        setDocumentsRead: brokerPensionPlanContributionActions.setDocumentsRead
    }
)(withRouter(BrokerPensionPlanPeriodicContributionView));
